module.exports = __webpack_public_path__ + "static/media/IMG_7169.d14bd6de.jpg";